import BaseStore from "@/v1/utils/BaseStore";

import { GET_COUNTRIES_START, GET_COUNTRIES_SUCCESS,GET_LIST_SUCCESS } from "./types";

const initialState = {
  countries: {
    loading: true,
    results: [],
  },
};

const store = new BaseStore("jurisdictions", initialState);

const reducer = {
  [GET_LIST_SUCCESS]: (state, payload) => ({
    ...state,
    loading: false,
    page: {
      ...state.page,
      totalElements: payload.results.length,
    },
    results: payload.results,
  }),
  [GET_COUNTRIES_START]: state => ({
    ...state,
    countries: {
      loading: true,
      results: [],
    },
  }),
  [GET_COUNTRIES_SUCCESS]: (state, payload) => ({
    ...state,
    countries: {
      loading: false,
      results: payload.results,
    },
  }),
};

export default store.reducer(reducer);
